<template>
  <div class="container">
    <homeHeader title="测试用例" ref="HomeHeader" :isShowProjectSelect="false" key="schedule"></homeHeader>
    <div class="main" v-if="isSearch">
      <div class="card">
        <div class="toolbar-dv">
          <toolBarBtn :parentData="this" :buttonVisible="buttonVisible" ref="toolBarBtn"></toolBarBtn>
        </div>
        <div class="table-dv">
          <div class="leftView">
            <navList
              :listData="typeList"
              title="类型"
              :listKey="'name'"
              indexKey="name"
              :indexValue="indexValue"
              @itemClick="changeType"
            ></navList>
          </div>
          <div class="rightView">
            <vxe-grid
              ref="xTable"
              resizable
              :column-config="{ minWidth: '80px' }"
              :data="tableData"
              size="mini"
              :cell-style="cellStyle"
              :mouse-config="{ area: true }"
              highlight-hover-row
              highlight-current-row
              :height="tableHeight"
              :columns="tableColumn"
              @cell-dblclick="handleDbClick"
              :menu-config="{
                body: { options: bodyMenus },
                visibleMethod: visibleMethod
              }"
            >
            </vxe-grid>
          </div>
        </div>
      </div>
    </div>
    <!-- 明细界面 -->
    <YKUseCaseDetail :parentData="this" :joinID="joinID" @SingleBack="SingleBack" v-if="!isSearch" />
    <!-- 编辑单据模态窗 -->
    <YKUseCaseEditModal ref="YKUseCaseEditModal" />
  </div>
</template>

<script>
import YKUseCaseDetail from './YKUseCaseDetail.vue'
import YKUseCaseEditModal from './YKUseCaseEditModal.vue'
export default {
  components: {
    YKUseCaseDetail,
    YKUseCaseEditModal
  },
  data() {
    return {
      buttonVisible: {
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        update: false,
        delete: false,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false, // 更多按钮是否显示
        refresh: false,
        save: false
      },
      searchFormVisible: false,
      // 表数据
      tableData: [
        {
          todo1: '1',
          todo2: '产品版本',
          todo3: '用例标题',
          todo4: '用例类型',
          todo5: '刘福',
          todo6: '2022-03-18',
          todo7: '刘福',
          todo8: '2022-03-18',
          todo9: '通过',
          todo10: '正常',
          todo11: '3',
          todo12: '0'
        },
        {
          todo1: '2',
          todo2: '产品版本',
          todo3: '用例标题',
          todo4: '用例类型',
          todo5: '刘福',
          todo6: '2022-03-18',
          todo7: '刘福',
          todo8: '2022-03-18',
          todo9: '不通过',
          todo10: '结束',
          todo11: '1',
          todo12: '1'
        },
        {
          todo1: '3',
          todo2: '产品版本',
          todo3: '用例标题',
          todo4: '用例类型',
          todo5: '刘福',
          todo6: '2022-03-18',
          todo7: '刘福',
          todo8: '2022-03-18',
          todo9: '暂无',
          todo10: '作废',
          todo11: '0',
          todo12: '0'
        }
      ],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 右键
      bodyMenus: [[]],
      tableColumn: [],
      // 树节点
      typeList: [
        {
          name: '铁塔基础版'
        },
        {
          name: '铁塔加强版'
        },
        {
          name: '铁塔完整版'
        },
        {
          name: '电杆标准版'
        }
      ],
      indexValue: '铁塔基础版',
      joinID: 0,
      isSearch: true
    }
  },
  created() {
    this.InitColumn()
  },
  methods: {
    getTypeForNumber(num) {
      switch (num) {
        case '1':
          return 'I'
        case '2':
          return 'II'
        default:
          return 'III'
      }
    },
    colorPriorities(num) {
      switch (num) {
        case '1':
        case '不通过':
        case '作废':
          return 'danger'
        case '2':
          return 'warning'
        case '通过':
        case '正常':
          return 'success'
        default:
          return 'primary'
      }
    },
    // 初始化列头
    InitColumn() {
      this.tableColumn = [
        {
          type: 'seq',
          width: '40px'
        },
        {
          field: 'todo1',
          title: '优先级',
          slots: {
            default: ({ row }) => {
              return [
                <el-tag size='small' type={this.colorPriorities(row.todo1)}>
                  {this.getTypeForNumber(row.todo1)}
                </el-tag>
              ]
            }
          }
        },
        {
          field: 'todo2',
          title: '产品版本'
        },
        {
          field: 'todo3',
          title: '用例标题'
        },
        {
          field: 'todo4',
          title: '用例类型'
        },
        {
          field: 'todo5',
          title: '制单人'
        },
        {
          field: 'todo6',
          title: '制单日期'
        },
        {
          field: 'todo7',
          title: '执行人'
        },
        {
          field: 'todo8',
          title: '执行时间'
        },
        {
          field: 'todo9',
          title: '执行结果',
          slots: {
            default: ({ row }) => {
              return [
                <el-tag size='small' type={this.colorPriorities(row.todo9)}>
                  {row.todo9}
                </el-tag>
              ]
            }
          }
        },
        {
          field: 'todo10',
          title: '用例状态',
          slots: {
            default: ({ row }) => {
              return [
                <el-tag size='small' type={this.colorPriorities(row.todo10)}>
                  {row.todo10}
                </el-tag>
              ]
            }
          }
        },
        {
          field: 'todo11',
          title: '运行次数'
        },
        {
          field: 'todo12',
          title: '失败次数'
        }
      ]
    },
    SingleBack() {
      this.isSearch = true
    },
    add() {
      this.$refs.YKUseCaseEditModal.formVisible = true
    },
    changeType(type) {
      this.indexValue = type.name
    },
    getList() {},
    // 右键控制菜单方法
    visibleMethod() {
      return true
    },
    // 双击查看明细数据
    handleDbClick({ row }) {
      this.$refs.xTable.closeTooltip()
      this.joinID = row.id
      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    cellStyle() {
      // 整行的状态：1.未解决 [超期、未超期]  2.解决 [超期、未超期]  3.取消
      return {}
    },
    // 切换产品类型
    changeSelect(type) {
      // 注意！每次切换必须缓存产品类型值，才能在保存和activated触发时取到当前选择的类型
      this.optionsValue = type
      this.$store.commit('set_productType', this.optionsValue)
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + 20, isSearchForm, isToolBar)
    }
  }
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
  display: flex;
  .leftView {
    width: 15%;
    margin-right: 15px;
    border-radius: 5px;
    box-shadow: #e2e2e2 0px 0px 3px;
    border: 1px solid #eeeeee;
    overflow: hidden;
    position: relative;
  }
  .rightView {
    width: calc(85% - 15px);
  }
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
